import { gql } from '@apollo/client';

export class Queries {
    static getFeatureFlag = gql`
        query GetFeatureFlag($key: String!, $defaultValue: Boolean!) {
            getFeatureFlag(key: $key, defaultValue: $defaultValue)
        }
    `;
}
